import React from 'react';
import { Button } from 'react-bootstrap';
import { Theme } from '../theme';

const ThemeToggle: React.FC<{ theme: Theme; onToggle: () => void }> = ({ theme, onToggle }) => {
  const label = theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme';
  return (
    <Button variant="outline-secondary" size="sm" onClick={onToggle} aria-label={label} title={label}>
      {theme === 'dark' ? 'Light' : 'Dark'}
    </Button>
  );
};

export default ThemeToggle;
